import { getLastMonth } from 'Shared/utils';
import { LINK } from '@constants';
import { ArrowRight, Button, Column, Icon, Row, Typography } from '@viewup/ui';
import { MonthlyRankingIntro } from 'app/ranking/_features/ui/MonthlyRankingIntro';
import { useRouter } from 'next/navigation';

export const EarnedRanking = () => {
  const router = useRouter();
  const lastMonth = getLastMonth();

  return (
    <Column gap={8}>
      <Row alignItems='center' justifyContent='space-between'>
        <Typography fontType='body.medium'>{lastMonth}월의 적립왕 TOP3</Typography>
        <Button
          onClick={() => router.push(LINK.RANKING)}
          rightContent={<Icon size='3XS' source={ArrowRight} />}
          size={'S'}
          variant='ghost.primary'
        >
          전체보기
        </Button>
      </Row>

      <MonthlyRankingIntro />
    </Column>
  );
};
